import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  ToastContainer as ReactToastifyToastContainer,
  toast,
} from 'react-toastify'

import './Toast.scss'

export const TOAST_VARIANT_SUCCESS = 'success'
export const TOAST_VARIANT_INFO = 'info'
export const TOAST_VARIANT_WARNING = 'warning'
export const TOAST_VARIANT_ERROR = 'error'
export const TOAST_VARIANT_UPSELL = 'upsell'

export const TOAST_POSITION_TOP_LEFT = 'top-left'
export const TOAST_POSITION_TOP_RIGHT = 'top-right'
export const TOAST_POSITION_TOP_CENTER = 'top-center'
export const TOAST_POSITION_BOTTOM_LEFT = 'bottom-left'
export const TOAST_POSITION_BOTTOM_RIGHT = 'bottom-right'
export const TOAST_POSITION_BOTTOM_CENTER = 'bottom-center'

export const Toast = ({ className, text }) => (
  <div className={classnames('c-toast', className)} data-mu-test='toast'>
    <div className='c-toast__body'>
      <span>{text}</span>
    </div>
    <button
      className='Toastify__close-button Toastify__close-button--success'
      type='button'
    >
      ✖
    </button>
  </div>
)

Toast.propTypes = {
  className: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}

export const ToastContainer = ({ position }) => {
  return (
    <ReactToastifyToastContainer
      className={classnames(
        'c-toast-container',
        position && `c-toast-container--${position}`,
      )}
    />
  )
}

ToastContainer.defaultProps = {
  position: TOAST_POSITION_TOP_RIGHT,
}

ToastContainer.propTypes = {
  position: PropTypes.oneOf([
    TOAST_POSITION_TOP_LEFT,
    TOAST_POSITION_TOP_RIGHT,
    TOAST_POSITION_TOP_CENTER,
    TOAST_POSITION_BOTTOM_LEFT,
    TOAST_POSITION_BOTTOM_RIGHT,
    TOAST_POSITION_BOTTOM_CENTER,
  ]),
}
